import React from "react";
import { Link } from "gatsby";
import resolveLink from "../../utils/resolveLink";

const FooterLink = (item) => {
  return (
    <Link
      className={`block font-display text-lg mb-1 uppercase !leading-7 tracking-normal transition duration-300 hover:text-red text-white`}
      to={resolveLink(item.target.cached_url)}
    >
      {item.name}
    </Link>
  );
};

export default FooterLink;
